export default __webpack_public_path__ + "static/media/back_white.f15a1c15.svg";